import type { TFunction } from 'i18next'
import { currentNight, dateRange, daysUntil, time, weekdayDay, weekdayDayMonth, weekdayLongDay } from '@/lib/format'
import type { Stay } from '@/services/reserva'

export interface Hero {
  subtitle: string
  countdown: string | null
  label: string | null
}

/** Cabecera de Tu estancia por fase (Inicio.dc.html: "17 días · para tu llegada · sábado 3, 16:00", "Hoy", "Noche 2 de 3", "2 h 40 min", "3 – 6 oct"). */
export function heroFor(stay: Stay, now: Date, lang: string, t: TFunction): Hero {
  const { checkIn, checkOut, nights } = stay.dates
  const subtitle = `${stay.unit.name} · ${weekdayDay(checkIn, lang)} – ${weekdayDayMonth(checkOut, lang)} · ${t('v2.estancia.cabecera.noches', { count: nights })}`
  switch (stay.phase) {
    case 'before': {
      const days = Math.max(0, daysUntil(checkIn, now))
      return { subtitle, countdown: t('v2.estancia.cabecera.dias', { count: days }), label: t('v2.estancia.cabecera.paraTuLlegada', { when: `${weekdayLongDay(checkIn, lang)}, ${time(checkIn, lang)}` }) }
    }
    case 'arrival':
      return { subtitle, countdown: t('v2.estancia.cabecera.hoy'), label: t('v2.estancia.cabecera.llegadaAPartir', { time: time(checkIn, lang) }) }
    case 'during':
      return {
        subtitle,
        countdown: t('v2.estancia.cabecera.noche', { n: Math.min(nights, currentNight(checkIn, now)), total: nights }),
        label: t('v2.estancia.cabecera.salidaEl', { when: t('v2.estancia.cabecera.aLas', { day: weekdayLongDay(checkOut, lang), time: time(checkOut, lang) }) }),
      }
    case 'checkout': {
      const minutes = Math.max(0, Math.round((new Date(checkOut).getTime() - now.getTime()) / 60000))
      const h = Math.floor(minutes / 60)
      const m = minutes % 60
      return { subtitle, countdown: h > 0 ? t('v2.estancia.cabecera.horasMin', { h, m }) : t('v2.estancia.cabecera.minutos', { m }), label: t('v2.estancia.cabecera.hastaLaSalida', { time: time(checkOut, lang) }) }
    }
    case 'after':
      return { subtitle, countdown: dateRange(checkIn, checkOut, lang), label: t('v2.estancia.cabecera.estanciaTerminada') }
    default:
      return { subtitle, countdown: dateRange(checkIn, checkOut, lang), label: null }
  }
}
